import $ from 'jquery';
import 'slick-carousel/slick/slick';

$(function() {
    $('.main-slider').slick({
        speed: 500,
        slidesToShow: 1,
        arrows: true,
        slidesToScroll: 1,
        infinite: false,
        asNavFor: '.sub-slider',
    });
    var slidecount = $('.sub-slider .item').length;
    $('.sub-slider').slick({
        dots: false,
        slidesToShow: slidecount,
        infinite: false,
        autoplay: false,
        asNavFor: '.main-slider',
        focusOnSelect: true
    });

    $('.slide-related').slick({
        speed: 500,
        slidesToShow: 4,
        arrows: true,
        slidesToScroll: 1,
        infinite: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    centerMode: true,
                    centerPadding: '26.4vw',
                    slidesToShow: 1
                }
            }
        ]
    });
})
